import { BaseApi } from '../base-api';

export class InsightsApi extends BaseApi {
  protected readonly passVersionInPrefix = false;

  fetchUnread = () => this.get('notifications/unread');
  createReview = (licenseId: number, threadId: string) => this.post(`/${licenseId}/reviews/${threadId}`);
}
